<template>
  <BaseButton
    id="modal-apple-login"
    color="white"
    class="button--apple w-full"
    :disabled="!isReady"
    @click="click"
  >
    {{ text }}
  </BaseButton>
</template>
<script>
import '../../../../../es6/shared/social_login_error.js.es6';
import '../../../../../es6/shared/apple_login_manager.js.es6';
import '../../../../../es6/views/quick_estimate/apple.js.es6';

import { csrfToken } from '@/utils';

import BaseButton from './BaseButton.vue';

export default {
  name: 'AppleLoginButton',
  emits: ['click', 'success', 'error'],
  components: {
    BaseButton,
  },
  props: {
    text: {
      type: String,
      default: 'Continue with Apple',
    },
    apiConfig: {
      type: Object,
      required: true,
    },
    trackingParams: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      appleLoginApi: null,
      isReady: false,
    };
  },
  methods: {
    click() {
      if (!this.isReady) {
        return;
      }

      this.$emit('click');

      this.appleLoginApi.triggerModal();
    },
  },
  mounted() {
    this.appleLoginApi = App.es6.views.quick_estimate.apple({
      appleUrl: this.apiConfig.appleUrl,
      appleClientId: this.apiConfig.clientId,
      appleRedirectUri: this.apiConfig.redirectUri,
      csrfToken: csrfToken(),
      buttonId: 'modal-apple-login',
      trackingParams: this.trackingParams,
      callback: (response) => {
        this.$emit('success', response);
      },
      onError: (message) => {
        this.$emit('error', message);
      },
    }).init(() => {
      if (!window._APPLE_API_ERROR) {
        this.isReady = true;
        return;
      }
      this.$emit('error', 'Apple Authentication is currently unavailable. Please try again later.');
      Rollbar.error('Apple initialize error: ', window._APPLE_API_ERROR);
    });
  },
};
</script>
